export default __webpack_public_path__ + "static/media/error.fea9e331.svg";